import type { ReactNode } from 'react'
import { SectionError } from './SectionError'

export const DashboardSection = ({
  children,
  error,
  hideOnError = false,
  isLoading,
  sectionName,
  skeleton,
}: {
  children: ReactNode
  error: Error | null
  hideOnError?: boolean
  isLoading: boolean
  sectionName: string
  skeleton: ReactNode
}) => {
  if (isLoading) return <>{skeleton}</>

  if (error) return hideOnError ? null : <SectionError sectionName={sectionName} />

  return <>{children}</>
}
